import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { HeaderContainer, HeaderLogo } from "@thrivetribe/mvf.ui.organisms.header";
import { Footer } from "../Footer";
import MasterLayout from "../MasterLayout";
import ErrorMessage from "ui/molecules/Errors/ErrorMessage";

export const ErrorBoundaryPage = () => {
  const loggedOutHeader = (
    <HeaderContainer>
      <HeaderLogo />
    </HeaderContainer>
  );
  return (
    <MasterLayout
      header={loggedOutHeader}
      footer={<Footer />}
      body={
        <>
          <ErrorMessage
            pageHeading={"An unexpected error has occured."}
            pageCopy={"An unexpected error has occured. Please try reloading the page."}
          >
            <Button
              onClick={() => {
                window.location.reload();
              }}
              variant="primary"
              color="primary"
              style={{ width: "100%", justifyContent: "center", marginBottom: "12px" }}
            >
              Reload the page
            </Button>
            <Button
              onClick={() => {
                window.location.href = `mailto:support@manvfat.com`;
              }}
              variant="secondary"
            >
              Contact The Dugout Support
              <ButtonArrow />
            </Button>
          </ErrorMessage>
        </>
      }
    />
  );
};
